import bannerCount, { safeParams as bannerCountSafeParams } from '../../../internal/platformMetrics/trackers/bannerCount';
import dashboardPageTemplates, { safeParams as dashboardPageTemplatesSafeParams } from '../../../internal/platformMetrics/trackers/dashboardPageTemplates';
import orgGlobalsAreaCount, { safeParams as orgGlobalsAreaCountSafeParams } from '../../../internal/platformMetrics/trackers/orgGlobalsAreaCount';
import stripeletCount, { safeParams as stripeletCountSafeParams } from '../../../internal/platformMetrics/trackers/stripeletCount';
import { translationCount, safeParams as translationSafeParams } from '../../../internal/platformMetrics/trackers/translationCount';
import { translationCountForMessageLength, safeParams as translationwithWeightSafeParams } from '../../../internal/platformMetrics/trackers/translationCountForMessageLength';
import usageByMount, { safeParams as usageByMountSafeParams } from '../../../internal/platformMetrics/trackers/usageByMount';
export const trackers = {
    bannerCount,
    dashboardPageTemplates,
    stripeletCount,
    usageByMount,
    orgGlobalsAreaCount,
    translationCount,
    translationCountForMessageLength
};
export const enabledTrackers = [
    bannerCount,
    dashboardPageTemplates,
    stripeletCount,
    usageByMount,
    orgGlobalsAreaCount,
    translationCount,
    translationCountForMessageLength
];
export const trackersSafeParams = [
    ...bannerCountSafeParams,
    ...dashboardPageTemplatesSafeParams,
    ...stripeletCountSafeParams,
    ...usageByMountSafeParams,
    ...orgGlobalsAreaCountSafeParams,
    ...translationSafeParams,
    ...translationwithWeightSafeParams
];
export function throwsIfNotMocked() {
    throw new Error("To properly assert tracking logic, make sure you call `jest.mock('src/observability/internal/platformMetrics/trackers')` within your test");
}

//# sourceMappingURL=index.js.map